import React from "react";

class InnerBody extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isScrolling: false };
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll(event) {
    if (this._timeout) {
      //if there is already a timeout in process cancel it
      clearTimeout(this._timeout);
    }
    this._timeout = setTimeout(() => {
      this._timeout = null;
      this.setState({
        isScrolling: false
      });
    }, 100);
    if (this.state.scrollStatus !== "scrolling") {
      this.setState({
        isScrolling: true
      });
    }
  }

  render() {
    const { children } = this.props;
    /*const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, { isScrolling: this.state.isScrolling })
    );
    */

    //onScroll={this.handleScroll}
    return (
      <div className="InnerBody" type={this.props.noSidebar ? "NoSidebar" : ""}>
        {this.props.isLoading ? (
          <div className="ProgressBar">
            <div className="indeterminate" />
          </div>
        ) : null}
        <div className="InnerBody-Container">
          {this.props.isLoading ? null : children}
        </div>
      </div>
    );
  }
}

export default InnerBody;



// WEBPACK FOOTER //
// ./src/components/InnerBody.js